export default __webpack_public_path__ + "static/logo-ea161ea4f7576a51a741fe9426ef6368.png";